// extracted by mini-css-extract-plugin
export default {"coverageBox":"coverage_coverageBox__iIP4+","leftBox":"coverage_leftBox__JAol-","rightBox":"coverage_rightBox__-7Fpz","mapBox":"coverage_mapBox__91Hpk"};